import { useTranslation } from 'react-i18next'

import { authorPath, getAuthorByName } from '@/features/authors/authors'
import { LocaleLink } from '@/navigation/LocaleLink'
import { article } from '@/shared/lib/articleStyles'

type ArticleBylineProps = {
    authorName: string
    readingMinutes: number
    bylineBy: string
}

export function ArticleByline({ authorName, readingMinutes, bylineBy }: ArticleBylineProps) {
    const { t } = useTranslation()
    const author = getAuthorByName(authorName)
    const displayName = author?.name ?? authorName

    return (
        <p className={article.byline}>
            <span className='inline-flex items-center gap-2'>
                <span>{bylineBy}</span>
                {author ? (
                    <LocaleLink
                        to={authorPath(author)}
                        className='inline-flex items-center gap-2 text-article-fg no-underline transition-colors hover:text-article-flame'
                    >
                        <img
                            src={author.avatarSrc}
                            alt=''
                            width={32}
                            height={32}
                            className='h-8 w-8 shrink-0 rounded-full object-cover'
                            decoding='async'
                        />
                        <strong className='font-bold'>{displayName}</strong>
                    </LocaleLink>
                ) : (
                    <strong className='font-bold text-article-fg'>{displayName}</strong>
                )}
            </span>
            <span className={article.bylineSep} aria-hidden>
                ·
            </span>
            <span className={article.readingTimeInline}>
                {t('learnPage.readingMinutes', '{{count}} min de lectura', {
                    count: readingMinutes,
                })}
            </span>
        </p>
    )
}
